/**
 * File to import and configure all used vue-libs
 */
import Vue from 'vue';
import VueTippy from 'vue-tippy';
import { ClientTable, ServerTable } from 'vue-tables-2';
import VueAlertify from 'vue-alertify';
import VModal from 'vue-js-modal';
import Datepicker from 'vuejs-datepicker';
import vSelect from 'vue-select';
import draggable from 'vuedraggable';
import VCalendar from 'v-calendar';

Vue.use(VueTippy);
Vue.use(VCalendar);

var vueTablesOptions = {
    perPage: 10,

    pagination: {
        chunk: 5,
    },

    sortIcon: {
        base: '',
        is: 'sort-desc',
        up: 'sort-asc',
        down: 'sort-desc',
    },
};

Vue.use(ServerTable, vueTablesOptions);
Vue.use(ClientTable, vueTablesOptions);

Vue.use(VueAlertify, {
    glossary: {
        title: 'Löschen',
        ok: 'OK',
        cancel: 'Abbrechen',
    },
    notifier: {
        // auto-dismiss wait time (in seconds)
        delay: 1.5,
        // default position
        position: 'bottom-right',
        // adds a close button to notifier messages
        closeButton: false,
    },
    theme: {
        ok: 'ajs-button--accept',
        cancel: 'ajs-button--decline',
    },
});

Vue.use(VModal, {
    dynamic: true,
    injectModalsContainer: true,
    dynamicDefaults: { height: 'auto', adaptive: true, pivotY: 0.3 },
});

Vue.component('datepicker', Datepicker);

Vue.component('v-select', vSelect);

Vue.component('draggable', draggable);
